export enum SessionStorageKeyEnum {
  BOOKING_TOKEN = 'BOOKING_TOKEN',
  RESCHEDULE_TOKEN = 'RESCHEDULE_BOOKING_TOKEN',
  // Per-tab random key used to encrypt the booking/reschedule blobs above so
  // customer PII is not stored as plaintext in sessionStorage. See
  // SessionStorageService for the at-rest encryption details and its limits.
  BOOKING_SESSION_KEY = 'BOOKING_SK',
  // The PaymentIntent minted for the CURRENT checkout, keyed to cart + promo
  // identity (#2157 round 2): reused across page refreshes so a reload never
  // mints a second PI — and, with a promo applied, never burns a second
  // redemption claim. Cleared together with the booking token.
  PAYMENT_INTENT_TOKEN = 'PAYMENT_INTENT_TOKEN',
  // The active /t/:slug tenant mount for this session (#2261) — plaintext,
  // not PII (already public in the URL). Restores tenant theming after the
  // Auth0 hosted-login round trip, whose redirect_uri is the bare origin.
  TENANT_SLUG = 'TENANT_SLUG',
}
